export default "/_next/static/images/2015-3x-256ae34b8fa2fd21853e09bba0e92167.png";